
import React from "react";
import { Spinner } from "react-bootstrap";
import { Sparkles } from "lucide-react";

interface RfqHeaderProps {
  title: string;
  description: string;
  isFillingAI: boolean;
  onFillWithAI: () => void;
}

export default function RfqHeader({
  title,
  description,
  isFillingAI,
  onFillWithAI,
}: RfqHeaderProps) {
  return (
    <div className="aida-header">
      <div className="header-top">
        <div>
          <h4 className="fw-bold title-yellow mb-1">{title}</h4>
          <div className="text-muted" style={{ fontSize: "13px" }}>
            {description}
          </div>
        </div>

        <button
          type="button"
          className="btn-ai-fill"
          onClick={onFillWithAI}
          disabled={isFillingAI}
        >
          {isFillingAI ? (
            <>
              <Spinner size="sm" animation="border" />
              Remplissage...
            </>
          ) : (
            <>
              <Sparkles size={15} />
              Remplir avec AI
            </>
          )}
        </button>
      </div>
    </div>
  );
}
